import { Box, TextField, Typography } from "@mui/material";

const Field = ({
  title,
  fieldName,
  placeholder,
  type,
  multiline,
  rows,
  style,
}) => {
  return (
    <Box sx={{ width: "100%", ...style }}>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "15px",
          fontFamily: "Montserrat",
        }}
      >
        {title} <span style={{ color: "red" }}>*</span>
      </Typography>
      <TextField
        label={placeholder}
        name={fieldName}
        variant="outlined"
        required
        fullWidth
        type={type}
        multiline={multiline}
        rows={rows}
      />
    </Box>
  );
};

export default Field;
